class ReusableSectionService {
    save(data) {
        return axios.post(Sincron.urls.saveTemplateSection, data)
    }
}

export default ReusableSectionService